import React from 'react';
import { openApiFetchGet } from '../../../store/openApiFetch';
import {
    Content,
    Panel,
    PanelBody,
    PanelRouterLink,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableHeadRow,
    TableRow,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../../elements';
import { Spinner } from '../../spinners';
import { DisplayMessage } from '../../utils/displayMessage';
import { NullableBoolean } from '../../utils/NullableBoolean';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadRegisteredServers() {
    const result = await openApiFetchGet('/api/registrations', {});
    return result;
}

async function loadRegistration() {
    const result = await openApiFetchGet('/api/registrationsClient', {});
    return result;
}

export function RegistrationsList() {
    const { data, isLoading } = useReactAsync(loadRegisteredServers, {}, []);
    const registration = useReactAsync(loadRegistration, {}, []).data;

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title="Registrations" icon="fa-cogs" />
                </TopbarLeft>
                <TopbarRight>
                    {(registration && registration.name && (
                        <PanelRouterLink
                            to={`/settings/registrations/${registration?.id}/edit/key/${registration?.secretKey}`}
                            text="Edit registration"
                            icon="fa fa-edit"
                            small={true}
                        />
                    )) || <PanelRouterLink to="/settings/registrations/add" text="Register" icon="fa fa-plus" small={true} />}
                </TopbarRight>
            </Topbar>
            <Content>
                <Tray>
                    <Panel>
                        {(isLoading && <Spinner />) || (
                            <>
                                {(registration && registration.name && (
                                    <PanelBody noPadding={true}>
                                        <Table>
                                            <TableHead>
                                                <TableHeadRow light={true}>
                                                    <TableHeader>Name</TableHeader>
                                                    <TableHeader>Host</TableHeader>
                                                    <TableHeader>ZXY Client</TableHeader>
                                                    <TableHeader>ZXY Name</TableHeader>
                                                    <TableHeader>Active</TableHeader>
                                                </TableHeadRow>
                                            </TableHead>
                                            <TableBody>
                                                {data &&
                                                    data.map((item) => (
                                                        <TableRow key={item.id} isRowSelected={registration?.id === item.id}>
                                                            <TableData> {registration?.id === item.id ? '[own registration]' : item.name} </TableData>
                                                            <TableData> {item.hostname} </TableData>
                                                            <TableData>
                                                                {' '}
                                                                <NullableBoolean value={item.isZxyCloudClient} useSymbols={true} />
                                                            </TableData>
                                                            <TableData> {item.zxyClientCompanyName} </TableData>
                                                            <TableData>
                                                                {' '}
                                                                <NullableBoolean value={item.status === 'enabled'} useSymbols={true} />
                                                            </TableData>
                                                        </TableRow>
                                                    ))}
                                            </TableBody>
                                        </Table>
                                    </PanelBody>
                                )) || (
                                    <div className="text-center p40">
                                        <DisplayMessage message="Server not registered" messageType="general" />
                                    </div>
                                )}
                            </>
                        )}
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
